module.exports = __webpack_public_path__ + "assets/images/premium-features/shifts-bulk-edit-ee5d55.svg";